import {
	RESTAURANT_LIST_BY_ZIP_SUCCESS,
	RESTAURANT_LIST_FAILURE,
	RESTAURANT_LIST_REQUEST,
	RESTAURANT_LIST_SUCCESS,
} from 'new-constants/api.constants';
import {RestaurantListState} from './restaurant-list.reducer.types';

const initialState: RestaurantListState = {
	cache: {},
	zipRestaurants: {
		restaurants: [],
		zip: null,
	},
	isFetchedOnce: false,
	isDataError: false,
};

export const restaurantListReducer = (previousState = initialState, action): RestaurantListState => {
	switch (action && action.type) {
		case RESTAURANT_LIST_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.appId]: {
						restaurants: action.payload.data.restaurants,
						globalMainCategories: action.payload.data.globalMainCategories,
					},
				},
				isFetchedOnce: true,
			};
			break;

		case RESTAURANT_LIST_BY_ZIP_SUCCESS:
			return {
				...previousState,
				zipRestaurants: {
					restaurants: action.payload.restaurants,
					zip: action.payload.zip,
				},
			};
			break;

		case RESTAURANT_LIST_FAILURE:
			return {
				...previousState,
				isDataError: action.isDataError,
			};
			break;
		default:
			return previousState;
	}
};
